import styled from 'styled-components';

import FormFieldComponent from '~/components/FormField';

export const FormField = styled(FormFieldComponent)`
  padding-bottom: 25px;
  margin: 4px 0;
`;
